import React, { useState, useContext, useEffect, useRef } from "react";
import { HeaderMenuContext } from "../../Contexts/HeaderMenuContext";
import { SearchMenuContext } from "../../Contexts/SearchMenuContext";
import {
  useNavigate,
  useLocation,
  NavLink,
} from "react-router-dom";
import v2logo from "../../images/Bitmap/png/Bitmap.png";
import FaqInactive from '../../images/faq-64.png'
import MobileMenu from "../../Components/MobileMenu";
import Search from "../../images/Shape_13/png/Shape.png";
import Profile from "../../Components/Profile";
import PopOverSearch from "../../Components/PopOverSearch";
import "../../Components/HeaderComponent.css";
import useModule from "../../hooks/useModule";
import BellNotification from "./BellNotification";
import { Modal, Switch, Tooltip, Checkbox } from "antd";
import { CloseOutlined } from '@ant-design/icons';
import QueryBuilderTabs from "../QueryBuilder/QueryBuilderTabs";
import advanceSearchIcon from '../../images/advanceSearch.svg';
import NewSearchResult from "../NewSearchResult";
import { QuestionMarkCircleIcon } from '@heroicons/react/solid'
import { useDebounce } from "use-debounce";
import routePathSegments, { routeNames } from "../../routeSegments";
import { FaFilter } from "react-icons/fa";
import { HiMagnifyingGlass } from "react-icons/hi2";
import { PeFilterContext } from "../../Contexts/PeFilterContext";

/** The above  component  is responsible for rendering the
navigation bar of a web application. */
const NavbarWrapper = ({ children }) => {
  const navigate = useNavigate();

  const { searchText,setSearchText } = useContext(HeaderMenuContext);
  const PEHeaderSearchMenu = useContext(SearchMenuContext);
  const { open, setOpen } = useContext(PeFilterContext);
  const FilteredData = [PEHeaderSearchMenu.data];
  const [popOver, setPopOver] = useState(false);
  const [popOverAdvance, setPopOverAdvance] = useState(false);
  const [currentTab, setcurrentTab] = useState();
  const [searchInput, setSearchInput] = useState("");
  const [debouncedSearchInput] = useDebounce(searchInput.trim(), 500);
  const [searchType, setSearchType] = useState(0);
  const [activeModule, setActiveModule] = useState('dashboard');
  const [showMobileSearchModal, setShowMobileSearchModal] = useState(false);
  const location = useLocation();
  const [previousURL, setPreviousURL] = useState(location.pathname + location.search);
  const { allowedModulesList } = useModule();
  const hideFilterBtn = location.pathname.includes(`/${routePathSegments.dashboard}`) || location.pathname.includes("/reports") || 
    location.pathname.includes("/notes") || location.pathname.includes("/faq") || location.pathname.includes("/definitions") || location.pathname.includes("/screener");
  const onlyVC = allowedModulesList.includes('vc') && !allowedModulesList.includes('pe') && !allowedModulesList.includes('ma') && !allowedModulesList.includes('re') && !allowedModulesList.includes('cfs')
  const onlyCFSorVC = (allowedModulesList.includes('vc') || allowedModulesList.includes('cfs')) && !allowedModulesList.includes('pe') && !allowedModulesList.includes('ma') && !allowedModulesList.includes('re')
  const isScreenerPage = location.pathname.includes("/screener"); 
const encodeSearchTerm = (term) => {
  try {
    new URL(term);
    return encodeURIComponent(term);
  } catch {
    return encodeURIComponent(term);
  }
};

const getModuleType = () => {
  const pathSegment = location.pathname?.split('/')[1];
  const isDashboardRoute = pathSegment === 'dashboard' || pathSegment === '';
  
  if (isDashboardRoute) return 'dashboard';
  if (pathSegment.includes('cfs')) return 'cfs';
  if (pathSegment.includes('ma')) return 'ma';
  if (pathSegment.includes('vc')) return 'vc';
  if (pathSegment.includes('re')) return 're';
  if (pathSegment.includes('pe')) return 'pe';
  return '';
};

// Function to construct search URL
const constructSearchURL = (searchTerm, type, moduleType) => {
  const encodedTerm = encodeSearchTerm(searchTerm);
  
  // If the previous URL contains 'funds' and moduleType is pe, vc, or re, use the specific funds route
  const isPreviousURLMatch = ['/pe-vc-funds', '/vc-funds', '/re-funds'].some(path => previousURL.includes(path));
  const isCurrentPathMatch = ['investors/fund', 'investors/re-fund', 'pe/funds', 're/funds', 'vc/funds'].some(path => location.pathname.includes(path));
  const isModuleTypeValid = ['pe', 'vc', 're'].includes(moduleType);

  if ((isPreviousURLMatch || isCurrentPathMatch) && isModuleTypeValid) {
    console.log(previousURL, 'previousURL');
    const fundsRouteKey = `${moduleType}FundsSearch`;
    const baseRoute = routeNames[fundsRouteKey];
    
    if (typeof baseRoute === 'function') {
      return baseRoute(encodedTerm, type);
    }
  }
  
  // Default behavior when no specific 'funds' URL
  if (!moduleType || moduleType === 'dashboard') {
    return routeNames.globalSearch(encodedTerm, type);
  }
  
  const routeKey = `${moduleType}GlobalSearch`; //peGlobalSearch
  const baseRoute = routeNames[routeKey];
  
  if (typeof baseRoute === 'function') {
    return baseRoute(encodedTerm, type);
  }
  
  return `/search?q=${encodedTerm}&type=${type}`;
};

useEffect(() => {
  // Store previous URL only if it's NOT a search URL
  if (!location.pathname.includes('/global-search')) {
    setPreviousURL(location.pathname + location.search);
  }
}, [location.pathname]);

useEffect(() => {
  const moduleType = getModuleType();
  setActiveModule(moduleType);
}, [location.pathname]);

  useEffect(() => {
    setSearchInput(searchText);
  }, [searchText]);

  useEffect(() => {
    // Handle edge case: if no match is found for searchType, default to 0 (Broad Match)
    const foundType = searchTypes.find(type => type.key === searchType);
    if (!foundType && searchType !== 0) {
      setSearchType(0);
    }
  }, [searchType]);

  useEffect(() => {
    if (debouncedSearchInput.length !== 0 && !isScreenerPage) {
      const searchURL = constructSearchURL(debouncedSearchInput, searchType, activeModule);
      
      const currentSearchParams = new URLSearchParams(location.search);
      const currentQuery = currentSearchParams.get('q');
      const currentType = currentSearchParams.get('type');
      
      if (currentQuery !== debouncedSearchInput || currentType !== searchType.toString()) {
        navigate(searchURL);
        searchRef.current.focus();
      }
    }
  }, [debouncedSearchInput, searchType, activeModule]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === "k") {
        event.preventDefault();
        searchRef.current.focus();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  const menuRef = useRef();
  const searchRef = useRef(null);
  const handleChange = (e) => {
    setSearchInput(e.target.value);
    setSearchText(e.target.value)
  }
  const handlePaste =(e)=>{
    // setSearchInput(e.clipboardData.getData('Text'));
    // setSearchText(e.clipboardData.getData('Text'))
    const pastedValue= e.clipboardData.getData('Text')
    // console.log(pastedValue,'pastedValue');
    if(pastedValue.length+1 > 3) {
    setPopOver(true)
    }
    if(pastedValue.length-1 === 0) {
      setPopOver(false)
      }
  }

  const handleClear = () => {
    setSearchInput('');
    setSearchText('');
    searchRef.current.focus();
    setSearchType(0);
    setTimeout(() => {
      navigate(previousURL || "/dashboard");
    }, 0);
  };

  const searchTypes = [
    // {
    //   label: "Phrase Match",
    //   key: 2
    // },
    {
      label: "Broad Match",
      key: 0
    },
    {
      label: "Exact Match",
      key: 1
    }
  ];

  const faqNavigationFinder = () => {
    const moduleType = getModuleType();
    if(moduleType == 'ma'){
      return routeNames.ma_faq
    } else if(moduleType == 're'){
      return routeNames.re_faq
    } else if(moduleType == 'cfs'){
      return routeNames.cfs_faq
    } else {
      return routeNames.pe_faq
    }
  };

  return (
    <>    
      {/* <PopOverAdvanceSearch
        show={popOverAdvance}
        onClose={() => setPopOverAdvance(false)}
        setPopOverAdvance= {setPopOverAdvance}
      />     */}

      <div className=" lg:fixed lg:z-[100] w-full lg:left-0 relative bg-white " >
        {/* <img src={beta} className='absolute z-[150] right-0 ' width={62}  />
        <div className="absolute hidden lg:flex items-center justify-center lg:z-[150] md:z-[150] z-[150] right-[-28px] h-[1.2rem] px-6 mt-3 lg:right-[-28px] md:right-[-27px] lg:mt-2 md:mt-2 rotate-45 bg-red-600 lg:px-6 xl:px-6 md:px-6 text-white">
          <h3 className="tracking-widest font-semibold text-sm ">BETA</h3>
        </div> */}

        {/* <div className=" bg-white"> */}
          <div className=" w-full fixed z-[10]">
            <div className="relative z-10 flex-shrink-0  bg-white border-b border-gray-200  ">
              <div>
                <div className="flex  lg:px-0 justify-between items-center lg:pr-2">
                  <div className="flex w-[40%]">
                    {/* <SideBarApp />   */}
                    <div className="md:hidden">
                      <span className="sr-only">Open sidebar</span>
                      <MobileMenu />
                    </div>
                    <div
                      className="bg-white rounded-full px-2 py-1 hidden md:flex text-sm cursor-pointer "
                      id="user-menu-button"
                      aria-expanded="false"
                      aria-haspopup="true"
                      onClick={() => navigate("/dashboard")}>
                      <img
                        className="h-9 w-21 rounded-full"
                        src={v2logo}
                        alt=""
                      />
                    </div>

                    <p className="border-r border-gray-200 h-[3rem]"></p>
                    <div className={`hidden md:flex pl-4 items-center space-x-2 w-full gap-2 ${isScreenerPage ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}>
                      <div className="w-full relative pl-[2.5rem] rounded-md  border border-slate-500 py-2">
                        <div className=" flex absolute z-10 inset-y-0 left-0 pl-3 items-center text-[#989898] pointer-events-none">
                          <img className="h-[17px] w-[17px]" src={Search} alt="search"/>
                        </div>
                        <input
                          type="search"
                          value={searchInput}
                          ref={searchRef}
                          id="globalSearchInput"
                          onChange={handleChange}
                          onPaste={handlePaste}
                          className="w-[96%] text-[15px] outline-none shadow-none bg-inherit text-black leading-[15px] tracking-[-0.28] font-sans_book_body"
                          placeholder="Search for Companies, Investors, Advisors, Investments, Exits, M&A"
                          autoComplete="off"
                        />
                        {searchInput && (
                          <div className="w-36 flex items-center absolute right-3 top-1/2 transform -translate-y-1/2 font-normal">
                            <select
                              className="mr-[.5rem] border border-[#E5E7EB] rounded-sm shadow-sm text-[#333333] text-[13px] outline-none p-1"
                              value={searchTypes.find(type => type.key === searchType)?.label || "Broad Match"}
                              onChange={(e) => {
                                const selectedType = searchTypes.find(type => type.label === e.target.value);
                                setSearchType(selectedType.key);
                              }}
                            >
                              {searchTypes.map(type => 
                                <option key={type.key} value={type.label}>
                                  {type.label}
                                </option>
                              )}
                            </select>
                            <button
                              type="button"
                              onClick={handleClear}
                              className="w-8 absolute right-0 top-1/2 transform -translate-y-1/2 text-red-600 font-medium"
                            >
                              &#x2715; {/* This is a Unicode character for a cross */}
                            </button>
                          </div>
                        )}
                      </div>
                      {/* { searchInput || isCFS || isRE || isMA || isNotifications || isRequests || isAlerts ? <></> :
                      <Tooltip title="Advanced Filter">
                        <img src={advanceSearchIcon} alt="advancesearch" className="h-[30px] cursor-pointer" onClick={() => setPopOverAdvance(true)}/>
                      </Tooltip>} */}
                      {hideFilterBtn ? <></> : <button
                        className="hidden md:block cursor-pointer"
                        onClick={() => setOpen(!open)}
                        aria-label="filter-button"
                      >
                        <FaFilter color="#bc8b20" size={21} />
                      </button>}

                    </div>
                  </div>
                      
                  <div className="flex items-center gap-2">
                  <button
                    className="cursor-pointer block sm-custom:hidden"
                    onClick={() => setShowMobileSearchModal(true)}
                    aria-label="mobile-search-button"
                  >
                    <HiMagnifyingGlass color="#333333" size={28}/>
                  </button>
                  {hideFilterBtn ? <></> : <button
                      className="cursor-pointer md:hidden"
                      onClick={() => setOpen(!open)}
                      aria-label="filter-button"
                    >
                      <FaFilter color="#bc8b20" size={21} />
                    </button>}
                  
                    <div className="md:flex items-center justify-between xl:pl-0">
                      <nav className="hidden md:flex space-x-10 mx-4">
                        <section>
                          <div
                            className="hidden md:flex flex-col items-center w-full "
                            x-data="{tab: 1}"
                          >
                            <div className={`flex flex-row items-center gap-5 w-full ${isScreenerPage ? "pointer-events-none opacity-50" : "" }`}>
                              {children}
                            </div>
                          </div>
                        </section>
                      </nav>
                      <div className="flex space-x-4 mr-3 items-center">
                        <p className="md:border-r border-gray-200 h-[3rem] "></p>                        
                        <Tooltip title={"FAQ"} placement="bottom">
                          <NavLink to={faqNavigationFinder()} className="mt-2">
                            <img src={FaqInactive} 
                              className="text-white-300 h-[30px]"
                              alt="FAQ"
                            />
                          </NavLink>
                        </Tooltip>
                        <BellNotification />                       
                        <div className="" ref={menuRef}>
                          <Profile />
                        </div>
                      </div>
                    </div>

                    {/* profile and notification end */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        {/* </div> */}
      </div>

      {/* Mobile Search Modal */}
      <Modal
        open={showMobileSearchModal}
        onCancel={() => setShowMobileSearchModal(false)}
        footer={null}
        width={250}
        centered
        closeIcon={<CloseOutlined />}
        bodyStyle={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100px'
        }}
      >
        <div className="flex flex-col items-center justify-center gap-4">
          {/* <HiMagnifyingGlass color="#333333" size={40} /> */}
          <p className="text-center text-gray-700 font-medium text-sm">
            {/* We recommend rotating your device to landscape mode for an optimal search experience. */}
            Search is available in landscape view.
          </p>
        </div>
      </Modal>
    </>
  );
};
export default NavbarWrapper;
